import React from 'react'

class Introduction extends React.Component {
  render() {
    return (
      <div className="content-container" id="introduction">
        <div className="content-title">診療科</div>
        <div className="introduction-subject">診療科目　　内科</div>
      </div>
    )
  }
}

export default Introduction

